import { useEffect, useRef } from 'react'
import { getAnswersMap } from '../components/chat/utils/chatAnswerHelpers'
import {
  createAnswerEntry,
  createDerivedAnswerEntry,
  upsertAnswerEntry,
} from '../components/chat/utils/chatAnswerEntryHelpers'

const useChatAnswers = ({
  collectedAnswers,
  questions,
  dispatch,
  setCollectedAnswers,
}) => {
  const collectedAnswersRef = useRef(collectedAnswers)

  useEffect(() => {
    collectedAnswersRef.current = collectedAnswers
  }, [collectedAnswers])

  const getCurrentAnswersMap = (
    answersList = collectedAnswersRef.current,
  ) => {
    return getAnswersMap(answersList)
  }

  const saveAnswer = ({
    step,
    text = null,
    photoUrl = null,
    extractedValue = null,
    isValid = true,
    attempt = 1,
    value = null,
    meta = {},
  }) => {
    const entry = createAnswerEntry({
      step,
      questionIndex: questions.findIndex(
        (question) => question.id === step.id,
      ),
      text,
      photoUrl,
      extractedValue,
      isValid,
      attempt,
      value,
      meta,
    })

    const updatedAnswers = [
      ...collectedAnswersRef.current,
      entry,
    ]

    collectedAnswersRef.current = updatedAnswers
    dispatch(setCollectedAnswers(updatedAnswers))

    return updatedAnswers
  }

  const upsertDerivedAnswer = (
    stepId,
    value,
    extra = {},
  ) => {
    const entry = createDerivedAnswerEntry({
      stepId,
      value,
      extra,
    })

    const updatedAnswers = upsertAnswerEntry({
      answers: collectedAnswersRef.current,
      entry,
    })

    collectedAnswersRef.current = updatedAnswers
    dispatch(setCollectedAnswers(updatedAnswers))

    return updatedAnswers
  }

  return {
    collectedAnswersRef,
    getCurrentAnswersMap,
    saveAnswer,
    upsertDerivedAnswer,
  }
}

export default useChatAnswers